<template>
  <quiz-layout>
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" :to="`/admin`">
          <div class="item__title">Lessons</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/users`">
          <div class="item__title">Users</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards`">
          <div class="item__title">Rewards</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards/claims`">
          <div class="item__title">Claims</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__title">Rewards Claims</div>
      <div class="content__group">
        <b-table responsive striped hover :items="claims" :fields="fields"></b-table>
      </div>
    </template>
  </quiz-layout>
</template>
<script>
import QuizLayout from "../layout/QuizLayout.vue";
import { RewardService } from "../data/services/rewards.service";
export default {
  components: { QuizLayout },
  data() {
    return {
      claims: [],
      fields: [
        {
          key: "username",
          label: "User",
        },
        {
          key: "emailAddress",
          label: "Email",
        },
        {
          key: "address",
          label: "Wallet Address",
        },
        {
          key: "rewardItem",
          label: "Reward",
        },
        {
          key: "amount",
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const rService = new RewardService();
      const rawList = await rService.list();
      this.claims = this.processData(rawList);
    },
    processData(list) {
      return list.map((item) => {
        const payload = {
          address: item.deliveryAddress,
          username: item.user.name,
          emailAddress: item.user.email,
          rewardItem: item.reward.title,
          amount: item.reward.quantity,
        };
        return payload;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar {
  &__menu {
    display: flex;
    flex-direction: column;
  }
}

.menu {
  &__item {
    display: flex;
    cursor: pointer;
    align-items: center;
    + .menu__item {
      margin-top: 10px;
    }
  }
}

.item {
  &__icon {
    width: 26px;
    margin-right: 15px;
    svg {
      width: 100%;
    }
  }
  &__title {
    color: #ffffff;
    font-size: 20px;
    line-height: 24px;
    &:hover {
      color: #f1bc04;
    }
  }
}
.content {
  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 12px;
  }
  &__group {
    padding: 20px;
    width: 100%;
    background: white;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
  }
}
</style>